import { render, staticRenderFns } from "./preview_check.vue?vue&type=template&id=4c36d39a&scoped=true&"
import script from "./preview_check.vue?vue&type=script&lang=js&"
export * from "./preview_check.vue?vue&type=script&lang=js&"
import style0 from "./preview_check.vue?vue&type=style&index=0&id=4c36d39a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c36d39a",
  null
  
)

export default component.exports